export const thuongHieu = {
  sections: {
    list: { title: 'Thương hiệu' },
    detail: { title: 'Thương hiệu' },
  },
  titles: { add: 'Thêm thương hiệu', edit: 'Sửa thương hiệu', create: 'Tạo thương hiệu' },
  columns: {
    code: 'Mã TH',
    summary: 'Tên thương hiệu',
    note: 'Ghi chú',
    status: 'Trạng thái',
    logo: 'Logo',
    soHangHoa: 'Số HH',
    nguoiTao: 'Người tạo',
    ngayTao: 'Ngày tạo',
    ngayCapNhat: 'Ngày cập nhật',
    onOffAction: 'Bật tắt',
  },
  filter: {
    searchPlaceholder: 'Tìm theo mã / tên thương hiệu...',
    textDetailTitle: 'Bộ lọc chi tiết',
    sortSection: 'Sắp xếp',
    sortField: 'Trường sắp xếp',
    sortDir: 'Chiều sắp xếp',
  },
  filters: {
    hintSection: 'Gợi ý',
    hintBody: 'Danh mục thương hiệu dùng cho hàng hóa.',
    statusAll: 'Tất cả',
    brandTreeSection: 'Thương hiệu',
    treeAll: 'Tất cả thương hiệu',
    treeSearch: 'Tìm kiếm thương hiệu',
  },
  sort: {
    ngayTao: 'Ngày tạo',
    maThuongHieu: 'Mã thương hiệu',
    tenThuongHieu: 'Tên thương hiệu',
  },
  status: {
    dangHoatDong: 'Đang hoạt động',
    ngungHoatDong: 'Ngừng hoạt động',
  },
  actions: {
    pause: 'Ngừng hoạt động',
    activate: 'Kích hoạt',
  },
  messages: {
    loadError: 'Không tải được danh sách thương hiệu.',
    deleteSuccess: 'Đã xóa thương hiệu.',
    noData: 'Không có thương hiệu.',
    listSummary: 'Tổng {count} mục',
    saveSuccess: 'Đã lưu thương hiệu.',
    statusChanged: 'Đã cập nhật trạng thái.',
    createSuccess: 'Tạo thương hiệu thành công',
    selectedCount: 'Đã chọn {count}',
    deleteSelected: 'Xóa đã chọn ({count})',
    bulkDeleteConfirm: 'Xóa {count} thương hiệu đã chọn?',
    bulkDeleteSuccess: 'Đã xóa {count} thương hiệu',
    bulkDeletePartial: 'Đã xóa {ok}/{total}. {failed} mục không xóa được.',
    bulkDeleteError: 'Xóa hàng loạt thất bại',
    bulkDeleteNoneSelected: 'Chưa chọn thương hiệu nào để xóa',
    hhCount: '{count} HH',
  },
  form: {
    tenThuongHieu: 'Tên thương hiệu',
    maThuongHieu: 'Mã thương hiệu',
    ghiChu: 'Ghi chú',
    logoHint: 'Tối đa 5MB. Định dạng png/jpg/jpeg. Có thể kéo thả ảnh vào khung.',
    logoChoose: 'Chọn logo',
    logoPaste: 'Dán logo',
    logoPasteHint: 'Kéo thả ảnh vào khung, dán từ clipboard hoặc link http(s).',
    logoDragDrop: 'Kéo thả ảnh vào đây',
  },
  validation: {
    tenRequired: 'Vui lòng nhập tên thương hiệu.',
    maSaiDinhDang: 'Mã phải theo dạng {prefix}xxx (vd. {prefix}001).',
  },
  import: {
    description:
      'File Excel gồm 3 cột: Mã thương hiệu (tuỳ chọn, dạng TH{mã dự án}-xxx, không trùng toàn hệ thống), Tên thương hiệu (bắt buộc), Ghi chú (tuỳ chọn). Để trống mã thì hệ thống tự sinh.',
    success: 'Đã nhập thương hiệu từ Excel.',
    failed: 'Nhập thương hiệu từ Excel thất bại.',
  },
  placeholders: {
    formTitle: 'Thương hiệu',
    formBody: '',
    tenThuongHieu: 'Nhập tên thương hiệu',
    maThuongHieu: 'Để trống sẽ tự sinh TH{mã dự án}-001. Mã không được trùng toàn hệ thống.',
    maThuongHieuTheoDuAn: 'Để trống sẽ tự sinh, hoặc nhập dạng {prefix}001',
  },
}
